<template>
  <div class="zsmService">
    <div class="content-box">
      <div class="top-title">官方电话</div>
      <div class="bto-title">
        <img src="https://qiniu.htknow.com/17931_9d322_1637152609.png?imageslim" alt="" />
        <div class="">{{ zsmServiceMobile }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      zsmServiceMobile: ''
    };
  },
  mounted() {
    this.$store.dispatch('zsm-dict/settingConfig', 'zsm_service_mobile').then(info => {
      this.zsmServiceMobile = info;
    });
  }
};
</script>

<style lang="scss" scoped>
.zsmService {
  width: 168px;
  height: 70px;
  box-sizing: border-box;
  position: fixed;
  right: 20px;
  bottom: 50%;
  transform: translateY(50%);
  z-index: 9;
  background: #ffffff;
  box-shadow: 0px 2px 16px rgb(155 178 220 / 25%);
  opacity: 1;
  border-radius: 4px;
  padding: 6px;
  color: #333333;
  .top-title {
    line-height: 1.6;
    color: #333333;
    text-align: center;
    box-sizing: border-box;
    font-size: 14px;
    font-weight: bold;
    font-family: PingFang SC;
  }
  .content-box {
    width: 156px;
    height: 58px;
    box-sizing: border-box;
    border: 1px solid rgba(153, 153, 153, 0.08);
    border-radius: 4px;
    margin: 0 auto;
    padding: 7px 18px;
    text-align: center;
    img {
      width: 12px;
      height: 12px;
      margin-right: 5px;
    }
    .bto-title {
      font-family: -apple-system, SF UI Text, PingFang SC, Arial, Hiragino Sans GB, Microsoft YaHei, WenQuanYi Micro Hei, sans-serif;
      line-height: 1.6;
      color: #333333;
      text-align: center;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      font-size: 14px;
    }
  }
}
</style>
